import React from 'react';
import {Link} from 'react-router';
import classnames from 'classnames';
import { get } from 'lodash';

class RowItemTinhHinhXuLyDonTaiDonVi extends React.Component {
  
  render() {
    const paramsDonViChuaChuyenPhongBan = () => {
      if (this.props.item.donVi.tenDonVi === 'Đơn chưa chuyển phòng ban') {
        return '&isPhongBanChuaChuyenDon=true'
      }
      return ''
    }
    return (
      <tr>
        <td>{this.props.count}</td>
        <td className='list-items-table'>
          {/* { this.props.item.coDonViCon === true && !this.props.item.isDonViCha  ?
            <Link
              className={classnames('txt-underline', {
                'ml20': !this.props.item.isDonViCha,
                'ml40': get(this.props.item, 'donVi.capHienThi') === 2
              })}
              to={'/theo-doi-giam-sat/tinh-hinh-xld-tai-don-vi/' + this.props.item.donVi.id}>
                {this.props.item.donVi ? this.props.item.donVi.tenDonVi : ''}
              </Link>
            : */}
            <div
              className={classnames('', {
                'ml20': !this.props.item.isDonViCha,
                'ml40': (get(this.props.item, 'donVi.capHienThi') === 2 && !this.props.isSearchDonVi) || (get(this.props.item, 'donVi.capHienThi') === 1 && this.props.isSearchDonVi ),
                'ml60': (get(this.props.item, 'donVi.capHienThi') === 2 && this.props.isSearchDonVi)
              })}>
              {this.props.item.donVi ? this.props.item.donVi.tenDonVi : ''}
            </div>
          {/* } */}
        </td>
        <td className='txt-center'>
          {
            this.props.item.dangXuLy && this.props.item.dangXuLy.dungHan > 0 && !this.props.item.isDonViCha?
              <Link className='black-val txt-underline' to={`/theo-doi-giam-sat/danh-sach-don/${this.props.item.donVi.id}?trangThaiDon=${localStorage.getItem('tdgs.phanHe') != 'XU_LY_DON' ? 'DANG_GIAI_QUYET' : 'DANG_XU_LY'}&tinhTrangXuLy=DUNG_HAN${paramsDonViChuaChuyenPhongBan()}`}>{this.props.item.dangXuLy ? this.props.item.dangXuLy.dungHan : 0}</Link>
            :
              <span className='black-val'>{this.props.item.dangXuLy ? this.props.item.dangXuLy.dungHan : 0}</span>
          }
        </td>
        <td className='txt-center'>
          {
            this.props.item.dangXuLy && this.props.item.dangXuLy.treHan > 0 && !this.props.item.isDonViCha ?
              <Link className='red-val txt-underline' to={`/theo-doi-giam-sat/danh-sach-don/${this.props.item.donVi.id}?trangThaiDon=${localStorage.getItem('tdgs.phanHe') != 'XU_LY_DON' ? 'DANG_GIAI_QUYET' : 'DANG_XU_LY'}&tinhTrangXuLy=TRE_HAN${paramsDonViChuaChuyenPhongBan()}`}>{this.props.item.dangXuLy ? this.props.item.dangXuLy.treHan : 0}</Link>
            :
              <span className='red-val'>{this.props.item.dangXuLy ? this.props.item.dangXuLy.treHan : 0}</span>
          }
        </td>
        <td className='txt-center'>
          {
            this.props.item.daXuLy && this.props.item.daXuLy.dungHan > 0 && !this.props.item.isDonViCha ?
              <Link className='black-val txt-underline' to={`/theo-doi-giam-sat/danh-sach-don/${this.props.item.donVi.id}?trangThaiDon=${localStorage.getItem('tdgs.phanHe') != 'XU_LY_DON' ? 'DA_GIAI_QUYET' : 'DA_XU_LY'}&tinhTrangXuLy=DUNG_HAN${paramsDonViChuaChuyenPhongBan()}`}>{this.props.item.daXuLy ? this.props.item.daXuLy.dungHan : 0}</Link>
            :
              <span className='black-val'>{this.props.item.daXuLy ? this.props.item.daXuLy.dungHan : 0}</span>
          }
        </td>
        <td className='txt-center'>
          {
            this.props.item.daXuLy && this.props.item.daXuLy.treHan > 0 && !this.props.item.isDonViCha ?
              <Link className='red-val txt-underline' to={`/theo-doi-giam-sat/danh-sach-don/${this.props.item.donVi.id}?trangThaiDon=${localStorage.getItem('tdgs.phanHe') != 'XU_LY_DON' ? 'DA_GIAI_QUYET' : 'DA_XU_LY'}&tinhTrangXuLy=TRE_HAN${paramsDonViChuaChuyenPhongBan()}`}>{this.props.item.daXuLy ? this.props.item.daXuLy.treHan : 0}</Link>
            :
              <span className='red-val'>{this.props.item.daXuLy ? this.props.item.daXuLy.treHan : 0}</span>
          }
        </td>
        <td className='txt-center black-val txt-bold'>{this.props.item.tongSo ? this.props.item.tongSo : 0}</td>
      </tr>
    );
  }
}

export default RowItemTinhHinhXuLyDonTaiDonVi;



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-giam-sat/datatable/RowItemTinhHinhXuLyDonTaiDonVi.jsx